export const PLAN_TEMPLATES_RESET_STATE = 'PLAN_TEMPLATES_RESET_STATE';
export const PLAN_TEMPLATES_CURRENT_ITEM = 'PLAN_TEMPLATES_CURRENT_ITEM';

export const PLAN_TEMPLATES_REQUEST_LOADING = 'PLAN_TEMPLATES_REQUEST_LOADING';
export const PLAN_TEMPLATES_REQUEST_SUCCESS = 'PLAN_TEMPLATES_REQUEST_SUCCESS';
export const PLAN_TEMPLATES_REQUEST_FAILED = 'PLAN_TEMPLATES_REQUEST_FAILED';

export const PLAN_TEMPLATES_CURRENT_ACTION = 'PLAN_TEMPLATES_CURRENT_ACTION';
export const PLAN_TEMPLATES_RESET_ACTION = 'PLAN_TEMPLATES_RESET_ACTION';
